.pie {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;
  overflow: hidden;
}
